<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/price-region" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditPriceRegion") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.RegionCode')"
              >
                <vs-input
                  :label="$t('setup.label.RegionCode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.regionCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.RegionName')"
              >
                <vs-input
                  :label="$t('setup.label.RegionName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.regionName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Country")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Country')"
                >
                  <v-select
                    label="countryName"
                    :options="teamById.countryData"
                    v-model="teamData.countryId"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.States")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.States')"
                >
                  <v-select
                    label="stateName"
                    multiple
                    :options="teamById.statesData"
                    v-model="teamData.states"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="editTeam">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const teamEmptyObj = {
  locale: "en",
  regionCode: "",
  regionName: "",
  countryId: "",
  stateName: "",
  states: [],
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      teamData: teamEmptyObj,
      data: {},
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      teamById: (state) => state.priceRegion.PriceRegionList,
    }),
  },
  methods: {
    async getPriceRegions() {
      try {
        await this.$store.dispatch("priceRegion/setPriceRegions", this.id);
        this.teamData = this.teamById;
        this.teamData.states = this.teamById.regionDetails;
        this.teamData.statesData = this.teamData.statesData.concat(
          this.teamData.regionDetails
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editTeam() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        delete this.teamData.statesData;
        delete this.teamData.countryData;
        delete this.teamData.regionDetails;
        delete this.teamData.isDefault;
        delete this.teamData.id;
        for (let i = 0; i < this.teamData.states.length; i++) {
          this.teamData.states[i] = this.teamData.states[i].id;
        }

        await this.$store.dispatch("priceRegion/editpriceRegionAction", {
          id: this.id,
          data: this.teamData,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Price Region Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/price-region`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },

    resetForm() {
      this.teamData = teamEmptyObj;
    },
    cancel() {
      this.$router.push(`/setup/price-region`);
    },
  },
  watch: {
    teamData() {},
  },
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getPriceRegions();
  },
};
</script>
